import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Asidebar from "../Header/Asidebar";
import { getData, getFile } from "../../FetchNodeServices";
import { InfinitySpin } from "react-loader-spinner";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";


const SurveyListing = () => {
  const [isActivated, setIsActivated] = useState(true);
  const [fullwidthwrapper, setFullwidthWrapper] = useState("");
  const [SurveyList, setSurveyList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // here I Fixed number of items per page!

  const customer = useSelector((state) => state.user.users[0]);
  const user = customer.userId;

  const navigate = useNavigate();

  const handleToggle = () => {
    setIsActivated(!isActivated);
    setFullwidthWrapper(isActivated ? "fullwrapper" : "");
  };

  const fetchSurveyList = async () => {
    try {
      let result = await getData("users/survey-list?userId=" + user);
      setSurveyList(result || []);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching surveys:", error);
    }
  };

  useEffect(() => {
    fetchSurveyList();
  }, []);

  const handleClick = (item) => {
    navigate("/esurvey-form", { state: { item } });
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1); // This to  Reset to first page when searching
  };

  const fillSurveyList = () => {

    // Here I Filter the survey list based on the search term
    const filteredSurveyList = SurveyList.filter((item) => {
      const searchString = searchTerm.toLowerCase();
      return (
        item.surveyCode.toLowerCase().includes(searchString) ||
        item.surveyName.toLowerCase().includes(searchString) ||
        item.country.toLowerCase().includes(searchString) ||
        item.status.toLowerCase().includes(searchString)
      );
    });

    // Sort the filtered surveys by surveyId in descending order(to show latest survey first)
    const sortedSurveyList = filteredSurveyList.sort((a, b) => b.surveyId - a.surveyId);

    // Calculate the index of the first and last items for the current page
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentSurveys = sortedSurveyList.slice(indexOfFirstItem, indexOfLastItem);

    return currentSurveys.map((item) => (
      <tr key={item.surveyId}>
        <td>
          <span
            style={{ cursor: 'pointer', color: 'green' }}
            onClick={() => handleClick(item)}
          >
            {item.surveyCode}
          </span>
        </td>
        <td>{item.surveyName}</td>
        <td>{item.country}</td>
        <td>
          <span className="start-text">{item.start}</span> / <span className="end-text">{item.end}</span>
        </td>
        <td>{item.conversion}</td>
        <td>{item.loi}</td>
        <td>
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16">
            <path
              fill="currentColor"
              d="M8 1.5a.5.5 0 0 1 .5-.5A6.5 6.5 0 0 1 15 7.5a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5zM7 3.522a.5.5 0 0 0-.545-.498a6 6 0 1 0 6.52 6.52a.5.5 0 0 0-.497-.544H7z"
            />
          </svg>
        </td>
        <td>{item.status}</td>
        {/* <td className="fs-16">
          <i className="bi bi-eye mx-1" onClick={() => handleClick(item)}></i>
          <Link to="/setting">
            <i className="bi bi-gear mx-1"></i>
          </Link>
        </td> */}
      </tr>
    ));
  };
  //
  const handleExportCsv = async () => {
    try {
      const response = await getFile("users/export-survey-csv?userId=" + user);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Survey_Details.csv");
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error exporting CSV:", error);
    }
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div>
      <Asidebar isActivated={isActivated} />
      <div id="wrapper" className={fullwidthwrapper}>
        <Header onclick={handleToggle} />
        <div className="container-fluid py-3">
          <div className="row">
            <div className="col-lg-7">
              <div className="card border-light-subtle">
                <ul className="nav nav-pills custom-nav-pills custom-background custom-navbar-height ">
                  <li className="nav-item">
                    <Link to="/survey-form"> <a className="nav-link active" aria-current="page" href="#">
                      Survey Form
                    </a></Link>

                  </li>
                  <li className="nav-item">
                    <Link to="/survey-programming">
                      <a className="nav-link" href="#">
                        Questions
                      </a>
                    </Link>

                  </li>
                  <li className="nav-item">
                    <Link to="/view-quota">
                      <a className="nav-link" href="#">
                        Quota
                      </a>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link">Field Work</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link">Survey Data</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link">Stats</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link">Analysis</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link">Reports</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div id="page_wrapper" className="py-3">
          <div className="card p-3 border-light-subtle mb-3">
            <ul className="breadcrumb m-0">
              <li>
                <i className="bi bi-people"></i> SurveyList
              </li>
            </ul>
          </div>

          <div className="card p-3 border-light-subtle">
            <div className="filter_header fs-12 lh-14">
              <div className="row">
                <div className="col-lg-6">
                  <div className="d-flex gap-1">
                    <div className="search_box">
                      <input
                        type="text"
                        className="w-100 form-control"
                        placeholder="Search Survey"
                        value={searchTerm}
                        onChange={handleSearch}
                      />
                    </div>
                    <div className="search_button">
                      <button className="btn btn-outline-light border text-dark py-0 fs-12 fw-600">
                        <i className="bi bi-funnel"></i> Filters
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="d-flex gap-2 justify-content-end mt-3 mt-lg-0">
                    <button className="btn btn-outline-light border text-dark py-0 fs-12 fw-600" onClick={handleExportCsv}>
                      <i className="bi bi-file-earmark-arrow-down fs-14"></i> Export as CSV
                    </button>
                    <Link to="/survey-form">
                      <button className="btn btn-success py-0 fs-12 fw-600">
                        <i className="bi bi-plus fs-15"></i> Add New Survey
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="table-responsive mt-3">
              <table className="table fs-14 lh-20">
                <thead className="table-light fs-12 lh-16 border-top">
                  <tr>
                    <th>Survey code</th>
                    <th>Survey name</th>
                    <th>Country</th>
                    <th>Start/End</th>
                    <th>Conversion</th>
                    <th>LOI</th>
                    <th>Stats</th>
                    <th>Status</th>
                    {/* <th>Action</th> */}
                  </tr>
                </thead>
                <tbody>
                  {isLoading && (
                    <tr>
                      <td colSpan={9} className="text-center">
                        <InfinitySpin visible={true} width="200" color="#4fa94d" ariaLabel="infinity-spin-loading" />
                      </td>
                    </tr>
                  )}
                  {fillSurveyList()}
                </tbody>
              </table>
            </div>

            <div className="text-center mt-4">
              <nav aria-label="Page navigation">
                <ul className="pagination">
                  <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                    <button className="page-link" onClick={() => paginate(currentPage - 1)}>
                      &laquo;
                    </button>
                  </li>
                  {[...Array(Math.ceil(SurveyList.filter((item) =>
                    item.surveyCode.toString().includes(searchTerm.toLowerCase()) ||
                    item.surveyName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    item.country.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    item.status.toLowerCase().includes(searchTerm.toLowerCase())).length / itemsPerPage)).keys()].map((_, index) => (
                      <li key={index} className={`page-item ${currentPage === index + 1 ? "active" : ""}`}>
                        <button className="page-link" onClick={() => paginate(index + 1)}>
                          {index + 1}
                        </button>
                      </li>
                    ))}
                  <li className={`page-item ${currentPage === Math.ceil(SurveyList.length / itemsPerPage) ? "disabled" : ""}`}>
                    <button className="page-link" onClick={() => paginate(currentPage + 1)}>
                      &raquo;
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SurveyListing;
